import { render, staticRenderFns } from "./TableEmptyState.vue?vue&type=template&id=630eecf5&scoped=true&"
import script from "./TableEmptyState.vue?vue&type=script&lang=js&"
export * from "./TableEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./TableEmptyState.vue?vue&type=style&index=0&id=630eecf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630eecf5",
  null
  
)

export default component.exports